import { autoApplyPromoCodeOnLogin } from './cart/cart-api-utils';
import { globalWindow } from './constants';
import { getCookie } from './cookies';
import { checkIfCustomer, IS_NATIVE_APP_CLIENT, promiseWithTimeout } from './helpers';

export const nativeBackupCouponApplier = (code: string) => {
  if (code && code !== '') {
    const userAgent = navigator.userAgent.toLowerCase();
    if (userAgent.includes('aloios/2.6.2') || userAgent.includes('aloandroid/2.4.1')) {
      if (window?.Shopify?.theme?.role === 'unpublished') console.warn('APPLYING CODE:' + code);
      window.location.href = `aloapp://apply-code/${code}`;
    }
  }
};

const getCurrentlyAppliedCode = () => {
  try {
    return getCookie('discount_code') || null;
  } catch (err) {
    console.log('Error getting currently applied discount code', err);
    return null;
  }
};

export const autoCouponApplicator = {
  init: async () => {
    const codeToApply = globalWindow?.AloAutoCouponApplicator?.settings?.code;
    if (!codeToApply || IS_NATIVE_APP_CLIENT || !checkIfCustomer()) return;
    // ? should we make 'skipCookieCheck' a theme settings? unlikely but perhaps in the future, for now will cause confusion for Aloversary; see CONTEXT below
    if (codeToApply) await applyDiscountCode(codeToApply, { skipCookieCheck: true });
  },
};

export const applyDiscountCode = async (
  code: string,
  // ? [CONTEXT] 'skipCookieCheck' is necessary: code can be incorrectly "consumed" + cookie isn't reset correctly
  // - ex if you go to regular checkout & return to cart page & to ShopPay (you don't get the discount code), the discount code has been "consumed" but the cookie is still there
  // - also needed to support muliple (valid) checkouts
  // - to work around limitations of Shopify Classic Checkout
  { skipCookieCheck = false } = {}
) => {
  try {
    const discountCode = code.toUpperCase();
    const currentlyAppliedCode = getCurrentlyAppliedCode();
    if (currentlyAppliedCode === discountCode && !skipCookieCheck) return;
    document.cookie = `discount_code=${discountCode}`;
    await promiseWithTimeout(1500, autoApplyPromoCodeOnLogin(discountCode));
  } catch (err) {
    console.log("Failed 'applyDiscountCode': ", err);
  }
};
